import { createAction, props } from '@ngrx/store';

import { HardwareInfo, IHDspace } from 'src/app/shared/interfaces/IHDspace';
import { PickUpStatus } from 'src/app/shared/services/frodo';

import { FinishPickupRequest, PickupIndicator, Schedule, Space } from './interfaces';

export const setPickupOrder = createAction(
  '[RemotePickup] Set Remote Pickup Success',
  props<{
    code?: string;
    spaces: Array<Space>;
    schedule: Schedule;
    indicator?: PickupIndicator;
  }>()
);

export const setPickupOrderFailure = createAction(
  '[RemotePickup] Set Remote Pickup Failure',
  props<{ error: any }>()
);

export const addPickup = createAction(
  '[RemotePickup] Add Pickup',
  props<{ code?: string; isDriverNotificationEnabled?: boolean }>()
);

export const addPickupSuccess = createAction(
  '[RemotePickup] Add Pickup Success',
  props<{
    code?: string;
    spaces: Array<Space>;
    schedule: Schedule;
    queuedAt?: number;
    position?: number;
    isOverflowArea?: boolean;
    status?: PickUpStatus;
    isOffline?: boolean;
  }>()
);

export const addPickupFailure = createAction('[RemotePickup] Add Pickup Failure');

export const startPickup = createAction(
  '[RemotePickup] Start Pickup',
  props<{ scheduleId: string; isOverflowArea?: boolean }>()
);

export const startPickupSuccess = createAction(
  '[RemotePickup] Start Pickup Success',
  props<{
    scheduleId: string;
    spaces?: Array<
      Pick<IHDspace, 'id'> & {
        hardwareInfo?: Pick<HardwareInfo, 'position'>;
        label?: string;
        section?: string;
      }
    >;
    startedAt: number;
    indicator?: PickupIndicator;
  }>()
);

export const startPickupFailure = createAction('[RemotePickup] Start Pickup Failure');

export const updatePickupState = createAction('[RemotePickup] Update Pickup State');

export const updatePickupStateSuccess = createAction(
  '[RemotePickup] Update Pickup State Success',
  props<{ status: PickUpStatus; position?: number }>()
);

export const setPickupActive = createAction('[RemotePickup] Set Pickup Active');

export const redirectBasedOnState = createAction('[RemotePickup] Redirect Based On State');

export const updateWaitingQueueState = createAction('[RemotePickup] Update Waiting Queue State');

export const clearRemotePickup = createAction('[RemotePickup] Clear Remote Pickup');

export const finishPickup = createAction(
  '[RemotePickup] Finish Pickup',
  props<FinishPickupRequest>()
);

export const finishPickupSuccess = createAction('[RemotePickup] Finish Pickup Success');

export const finishPickupFailure = createAction('[RemotePickup] Finish Pickup Failure');

export const setShouldHandleDriverNotification = createAction(
  '[RemotePickup] Set Should Handle Driver Notification',
  props<{ shouldHandleDriverNotification: boolean }>()
);

export const setConfirmAt = createAction(
  '[RemotePickup] Set Confirm At',
  props<{ confirmAt: number }>()
);
